<template>
  <div class="home-page">
    <div class="first-box">
      <img class="main-logo" src="../../../public/static/indexUse/logo.png" alt="AIJU SCHOOL" />
      <div class="explore-more" @click="scrollToSecond">
        <span>{{ $t('探索更多') }}</span>
        <dol-icon type="DownOutlined" />
      </div>
    </div>

    <div class="second-box" ref="secondBox">
      <div class="box-container">
        <div class="left-content">
          <div>
            <h2 class="title">{{ $dt(coreTitle, 'name') }}</h2>
            <p class="desc">{{ $dt(coreDesc, 'name') }}</p>
          </div>
          <div class="tag-list">
            <div v-for="tag in tagList" :key="tag.id" class="tag-item" :class="`tag-${tag.id}`">
              <div class="tag-name">{{ $dt(tag, 'name') }}</div>
              <div class="tag-desc">{{ $dt(tag, 'desc') }}</div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <img class="campus-img" src="../../../public/static/indexUse/index-1.png" alt="校园生活" />
          <div class="img-desc-box">
            <div class="img-title">{{ $dt(campusTitle, 'name') }}</div>
            <div class="img-desc">{{ $dt(campusDesc, 'name') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="third-box">
      <div class="third-container">
        <div class="third-title">{{ $t('爱菊教育') }}</div>
        <div class="img-row">
          <div v-for="i in 4" :key="i" class="edu-item">
            <img class="edu-img" :src="eduImage[i-1]" />
            <div class="edu-text" :style="eduText[i-1].style">{{ $dt(eduText[i - 1], 'text') }}</div>
          </div>
        </div>
        <div class="img-row">
          <div v-for="i in 4" :key="i" class="edu-item">
            <img class="edu-img" :src="eduImage[i+3]" />
            <div class="edu-text" :style="eduText[i+3].style">{{ $dt(eduText[i + 3], 'text') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="fourth-box">
      <div class="fourth-container">
        <div class="fourth-title">{{ $t('新闻与活动') }}</div>
        <a-row class="news-list" :gutter="26">
          <a-col span="8" v-for="item in newsList" :key="item._id">
            <div class="news-item">
              <img class="news-img" :src="item.image" />
              <div class="news-title">{{ $dt(item, 'title') }}</div>
              <div class="news-content">{{ $dt(item, 'content') }}</div>
              <div class="news-createTime">{{ item.createTime }}</div>
            </div>
          </a-col>
        </a-row>
        <div class="button-row">
          <div class="as-button">{{ $t('查看更多') }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import tu1 from '../../../public/static/indexUse/linShiTu/tu1.png';
import tu2 from '../../../public/static/indexUse/linShiTu/tu2.png';
import tu3 from '../../../public/static/indexUse/linShiTu/tu3.png';
import tu4 from '../../../public/static/indexUse/linShiTu/tu4.png';
import tu5 from '../../../public/static/indexUse/linShiTu/tu5.png';
import tu6 from '../../../public/static/indexUse/linShiTu/tu6.png';
import tu7 from '../../../public/static/indexUse/linShiTu/tu7.png';
import tu8 from '../../../public/static/indexUse/linShiTu/tu8.png';
import n1 from '../../../public/static/indexUse/linShiTu/n1.png';
import n2 from '../../../public/static/indexUse/linShiTu/n2.png';
import n3 from '../../../public/static/indexUse/linShiTu/n3.png';

export default {
  name: "home",
  data() {
    return {
      eduImage: [tu1, tu2, tu3, tu4, tu5, tu6, tu7, tu8],
      eduText: [
        {
          text: '小学部创新融合班',
          textEn: 'Primary Int\'l Class',
          style: { background: 'linear-gradient( 180deg, rgba(93,153,71,0) 0%, #5D9947 100%)' }
        },
        {
          text: '初中部科创融合班',
          textEn: 'Junior High STEM',
          style: { background: 'linear-gradient( 180deg, rgba(222,161,40,0) 0%, #EC971B 100%)' }
        },
        {
          text: '小学初中双语融合班',
          textEn: 'Bilingual Program',
          style: { background: 'linear-gradient( 180deg, rgba(50,104,158,0) 0.03%, #32689E 99.95%)' }
        },
        {
          text: '高中部',
          textEn: 'Senior High',
          style: { background: 'linear-gradient( 180deg, rgba(100,92,192,0) 0%, #645CC0 100%)' }
        },
        {
          text: '日本EJU高中融合课程',
          textEn: 'Japan EJU',
          style: { background: 'linear-gradient( 180deg, rgba(222,161,40,0) 0%, #EC971B 100%)' }
        },
        {
          text: '香港DSE高中融合课程',
          textEn: 'HK DSE',
          style: { background: 'linear-gradient( 180deg, rgba(50,104,158,0) 0.03%, #32689E 99.95%)' }
        },
        {
          text: '新加坡UIA高中融合课程',
          textEn: 'SG UIA',
          style: { background: 'linear-gradient( 180deg, rgba(100,92,192,0) 0%, #645CC0 100%)' }
        },
        {
          text: '英澳WACE高中融合课程',
          textEn: 'UK-AUS WACE',
          style: { background: 'linear-gradient( 180deg, rgba(93,153,71,0) 0%, #5D9947 100%)' }
        }
      ],
      coreTitle: { name: '爱知博艺 菊雅竞芳', nameEn: 'Love Knowledge & Art, Pursue Elegance & Excellence' },
      coreDesc: {
        name: '在爱菊，博雅教育不仅仅是跨学科知识。这是一种有意识地连接人、想法和解决方案，让世界变得更好的方式。在这里，我们用不同的视角看世界，发现新的路径，寻找新的答案。通过探索艺术、科学、语言和人文学科，我们对自己、同龄人以及周围世界的理解。',
        nameEn: 'At Aiju, liberal arts education is more than interdisciplinary knowledge. It is a conscious way to connect people, ideas and solutions to make the world a better place. Here, we see the world from different perspectives, discover new paths and find new answers. Through exploring art, science, language and humanities, we deepen our understanding of ourselves, our peers and the world around us.'
      },
      tagList: [
        {
          id: 1,
          name: '爱知',
          nameEn: 'Love Learn',
          desc: '热爱知识，夯实基础',
          descEn: 'Love knowledge, lay a solid foundation'
        },
        {
          id: 2,
          name: '博艺',
          nameEn: 'Art Skill',
          desc: '通晓科艺，增长才干',
          descEn: 'Master science and art, enhance ability'
        },
        {
          id: 3,
          name: '菊雅',
          nameEn: 'Grace Dignity',
          desc: '举止优雅，高雅情趣',
          descEn: 'Elegant manner, noble taste'
        },
        {
          id: 4,
          name: '竞芳',
          nameEn: 'Grow Excel',
          desc: '合作自信，全面发展',
          descEn: 'Cooperative and confident, all-round development'
        }
      ],
      campusTitle: { name: '校园生活', nameEn: 'Campus Life' },
      campusDesc: {
        name: '校园坐落于松江高新开发区(文俊东路100号),占地面积约102亩,具备现代化的建筑和先进的设施,更好的为师生提供服务。',
        nameEn: 'The campus is located at No.100 East Wenjun Road, Songjiang High-tech Development Zone, covering an area of about 102 mu. It has modern buildings and advanced facilities to better serve teachers and students.'
      },
      isScrolling: false,
      newsList: [
        {
          _id: 1,
          image: n1,
          title: '1月23-24日 | 2026年VEX机器人锦标赛',
          titleEn: 'Jan 23-24 | 2026 VEX Robotics Championship',
          content: '博雅教育不仅仅是跨学科知识。这是一种有意识地连接人、想法和解决方案，让世界变得更好的方式。在这里，我们用不同的视角看世界，发现新的路径，寻找新的答案。',
          contentEn: 'Liberal arts education is more than interdisciplinary knowledge. It connects people, ideas and solutions to make the world better. We see the world from new angles and find new paths.',
          createTime: '2026-01-12'
        },
        {
          _id: 2,
          image: n2,
          title: '1月28日 | 七年级放假说明会',
          titleEn: 'Jan 28 | Grade 7 Holiday Briefing',
          content: '博雅教育不仅仅是跨学科知识。这是一种有意识地连接人、想法和解决方案，让世界变得更好的方式。在这里，我们用不同的视角看世界，发现新的路径，寻找新的答案。',
          contentEn: 'Liberal arts education is more than interdisciplinary knowledge. It connects people, ideas and solutions to make the world better. We see the world from new angles and find new paths.',
          createTime: '2026-01-20'
        },
        {
          _id: 3,
          image: n3,
          title: '2026校园师生慈善音乐会',
          titleEn: '2026 Campus Charity Concert',
          content: '博雅教育不仅仅是跨学科知识。这是一种有意识地连接人、想法和解决方案，让世界变得更好的方式。在这里，我们用不同的视角看世界，发现新的路径，寻找新的答案。',
          contentEn: 'Liberal arts education is more than interdisciplinary knowledge. It connects people, ideas and solutions to make the world better. We see the world from new angles and find new paths.',
          createTime: '2026-01-22'
        }
      ]
    };
  },
  methods: {
    scrollToSecond() {
      // this.$refs.secondBox.scrollIntoView({ behavior: 'smooth' });

      const headerHeight = 156; // 对应header的固定高度80px
      const target = this.$refs.secondBox;
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: targetTop - headerHeight,
        behavior: 'smooth'
      });
    },
    handleWheel(e) {
      if (this.isScrolling) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isTop = scrollTop < 100;
      const isDown = e.deltaY > 0;

      if (isTop && isDown) {
        e.preventDefault();
        this.isScrolling = true;
        this.scrollToSecond();
        setTimeout(() => {
          this.isScrolling = false;
        }, 1000);
      }
    }
  },
  mounted() {
    // window.addEventListener('wheel', this.handleWheel, { passive: false });
  },
  beforeUnmount() {
    // window.removeEventListener('wheel', this.handleWheel);
  },
};
</script>

<style scoped lang="scss">
.home-page {
  width: 100%;

  .first-box {
    width: 100%;
    height: 700px;
    background: url("../../../public/static/indexUse/bg.png") no-repeat center / cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-logo {
      height: 220px;
      width: auto;
      object-fit: contain;
    }

    .explore-more {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      transition: opacity 0.3s ease;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .second-box {
    width: 100%;
    height: 650px;
    margin: 96px 0;
    box-sizing: border-box;

    .box-container {
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 120px;

      .left-content {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          font-size: 22px;
          font-weight: bold;
          color: #003C82;
          margin: 0 0 16px 0;
          line-height: 1.4;
        }

        .desc {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
          margin: 0 0 40px 0;
        }

        .tag-list {
          display: flex;
          flex-wrap: wrap;

          .tag-item {
            width: 50%;
            display: flex;
            flex-direction: column;
            gap: 8px;

            .tag-name {
              width: 120px;
              height: 120px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 32px;
              font-weight: bold;
              margin: 0 12px 16px;
              text-align: center;
            }

            .tag-desc {
              width: 144px;
              font-size: 16px;
              text-align: center;
              margin-bottom: 36px;
            }

            &.tag-1 {
              color: #CD497E;

              .tag-name {
                background: rgba(#CD497E, 0.2);
              }
            }

            &.tag-2 {
              color: #5D9947;

              .tag-name {
                background: rgba(#5D9947, 0.2);
              }
            }

            &.tag-3 {
              color: #DEA128;

              .tag-name {
                background: rgba(#DEA128, 0.2);
              }
            }

            &.tag-4 {
              color: #32689E;

              .tag-name {
                background: rgba(#32689E, 0.2);
              }
            }
          }
        }
      }

      .right-content {
        flex: 1;
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        .campus-img {
          width: 100%;
          height: 100%;
        }

        .img-desc-box {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 230px;
          padding: 30px 158px 30px 32px;
          background: linear-gradient(180deg, rgba(0, 60, 130, 0) 0%, #003C82 100%);
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          .img-title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 12px;
          }

          .img-desc {
            font-size: 16px;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .third-box {
    background: url("../../../public/static/indexUse/thirdBg.png") no-repeat center / cover;
    padding: 96px 0;

    .third-container {
      width: 1280px;
      margin: auto;

      .third-title {
        font-weight: 600;
        font-size: 32px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 32px;
      }

      .img-row {
        display: flex;
        justify-content: space-between;
      }

      .img-row + .img-row {
        margin-top: 12px;
      }

      .edu-item {
        position: relative;
        transition: all 0.2s ease;
        cursor: pointer;

        &:hover {
          transform: scale(1.02);
          box-shadow: 0 16px 32px rgba(0, 30, 70, 0.25), 0 8px 16px rgba(0, 30, 70, 0.18);
          z-index: 10;
        }
      }

      .edu-img {
        width: 314px;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .edu-text {
        position: absolute;
        width: 100%;
        bottom: 0;
        display: flex;
        align-items: flex-end;
        padding: 32px;
        height: 116px;
        font-weight: 600;
        font-size: 20px;
        color: #FFFFFF;
      }
    }
  }

  .fourth-box {
    background-color: white;
    padding: 96px 0;

    .fourth-container {
      width: 1280px;
      margin: auto;

      .fourth-title {
        font-size: 32px;
        color: #003C82;
        margin-bottom: 24px;
        font-weight: bold;
      }

      .no-data {
        color: #999999;
        padding: 24px;
        font-size: 16px;
        text-align: center;
      }

      .news-item {
        position: relative;
        cursor: pointer;
      }

      .news-img {
        width: 100%;
        height: 280px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 16px;
      }

      .news-title {
        font-size: 20px;
        color: #003C82;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .news-content {
        height: 60px;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        margin-bottom: 8px;
      }

      .news-createTime {
        color: #999999;
        line-height: 20px;
      }
    }

    .button-row {
      display: flex;
      justify-content: center;
      margin-top: 36px;

      .as-button {
        display: inline-block;
        padding: 22px 74px;
        background-color: #003C82;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }

}
</style>
